export default __webpack_public_path__ + "static/media/BelfastHomelessnessv1.1220629BelfastInclusionHealthServicereferralpathwayV1_1_flowchart.9b31edbe.jpg";